import React from "react";
import { IconName } from "Components/Icons/Icon";
import { Row, Col } from "reactstrap";
import StatsOverview from "./StatsOverview";

export interface DashboardStat {
  title: string;
  value: number;
  iconName: IconName;
  iconBg?: string;
  prefix: string;
  suffix: string;
  separator?: string;
  decimal?: number;
  onClick?: () => void;
}

interface Props {
  stats: DashboardStat[];
}

const DashboardStatsOverview: React.FC<Props> = ({ stats }) => {
  return (
    <Row className="gy-3 mb-2">
      {stats.map((item, index) => (
        <Col
          xxl="6"
          xl="6"
          lg="12"
          md="12"
          sm="12"
          className="dashboard-stats"
          key={index}
        >
          <StatsOverview
            title={item.title}
            value={item.value}
            iconName={item.iconName}
            iconBg={item.iconBg}
            prefix={item.prefix}
            suffix={item.suffix}
            separator={item.separator}
            decimal={item.decimal}
            onClick={item.onClick}
          />
        </Col>
      ))}
    </Row>
  );
};

export default React.memo(DashboardStatsOverview);
